import { BoxProps as MantineBoxProps, Box as MantineBox } from '@mantine/core';

export type BoxProps = MantineBoxProps;

export const Box = MantineBox as typeof MantineBox;

Box.displayName = 'Box';
